import { render, staticRenderFns } from "./SupportDropDownStatus.vue?vue&type=template&id=09afdd11&scoped=true&"
import script from "./SupportDropDownStatus.vue?vue&type=script&lang=ts&"
export * from "./SupportDropDownStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SupportDropDownStatus.vue?vue&type=style&index=0&id=09afdd11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09afdd11",
  null
  
)

export default component.exports